<!--Banner part code-->

<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel  uk-flex-center uk-flex-middle"
            style="background-image: url(../../assets/portfoliobanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" style="padding-top: 40px;">

                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical" style="margin-bottom: 10px;">
                        Let’s Build Something Great </h1>
                </div>
                <div>
                    <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style="font-size: 20px;">Our efforts - designed with skill & quality.
                         Offering you the immense scope of solutions implemented by us with the high-quality standard.


                    </p>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- <br>
<br> -->
<!--Banner part code ends-->
<!-- <div class="uk-section "> -->
<div class="uk-container uk-margin-large">
    
<ul class="uk-subnav uk-subnav-pill uk-flex-center" uk-switcher="media: @s" >
    
                <li class="uk-active tab-item"><a href="#">Web Application</a></li>

                <li class="tab-item">
                    <a href="#">Mobile Application</a>
                    
                </li>
                <li class="tab-item"><a href="#">Ecommerce Application</a></li>
                
            </ul>
      
<ul class="uk-switcher uk-margin-large">
<li>
<div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
    <div>
        <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
                <img src="assets/pro1.jpg" alt="">
            </div>
            <div class="uk-card-body">
                <h3 class="uk-card-title">Web App</h3>
                <p class="uk-text-justify" style="word-spacing: -1px;letter-spacing : -1px">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
               <p> <a class="uk-link" href="http://sign-matrimony.herokuapp.com">Visit Website</a></p>
            </div>
        </div>
    </div>
    <div>
        <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
                <img src="assets/pro2.jpg" alt="">
            </div>
            <div class="uk-card-body">
                <h3 class="uk-card-title">Daily Mart</h3>
                <p class="uk-text-justify"style="word-spacing:-1px;letter-spacing: -1px">Daily Mart believes in providing the highest level of customer service and is continuously innovating to meet customer expectations.</p>
                <p> <a class="uk-link" href="#">Visit Website</a></p>
            </div>
        </div>
    </div>
    <div>
        <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
                <img src="assets/pro3.jpg" alt="">
            </div>
            <div class="uk-card-body">
                <h3 class="uk-card-title">Fly Buy </h3>
                <p class="uk-text-justify" style="word-spacing: -1px;letter-spacing:-1px">An online store available 24 hours a day. We focused on selling fashion and lifestyle products, which you can buy easily through our user friendly website.</p>
                <p> <a class="uk-link" href="#">Visit Website</a></p>
            </div>
        </div>
    </div>
    <div>
        <div class="uk-card uk-card-default">
            <div class="uk-card-media-top">
                <img src="assets/pro4.jpg"  alt="">
            </div>
            <div class="uk-card-body">
                <h3 class="uk-card-title">Websoul Recharge </h3>

                <p class="uk-text-justify" style="word-spacing: -1px; letter-spacing: -1px;">Websoul Recharge as the go-to place for international mobile top-up.Digital prepaid
                     credit lets you enjoy the things you like on your terms.<!-- And we’ve made it our mission
                      to ensure that buying digital credit is fast, safe and simple.--></p>

                          <p> <a class="uk-link" href="#">Visit Website</a></p>
            </div>
        </div>
    </div>
</div>
</li>
<li>
    <div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>
            <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                    <img src="assets/portfolio/busmain.jpg" style="height: 500px; width: 400px;" alt="app">
                </div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">Travel Buddy App</h3>
                    <p>Travel buddy app is a bus ticket booking software enables users to reserve the ticket by selecting their seats using the internet.</p>
                    <p> <a class="uk-link" href="example-project">View Screens</a></p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                    <img src="assets/portfolio/chat1.jpg" style="height: 500px; width: 400px;" alt="chat app">
                </div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">Chat App</h3>
                    <p>Chat App is a instant messaging app.This makes Communication through network.You can search registered users on chat app and chat them.</p>
                    <p> <a class="uk-link" href="exam-project">View Screens</a></p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                    <img src="assets/portfolio/fruit3.jpg"  style="height: 500px; width: 400px;" alt="portfolio">
                </div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">Food Mart</h3>
                    <p>Food Mart ia an app believes in providing the highest level of customer service and is continuously innovating to meet customer expectations.</p>
                    <p> <a class="uk-link" href="exa-project">View Screens</a></p>
                </div>
            </div>
        </div>
        <div>
            <div class="uk-card uk-card-default">
                <div class="uk-card-media-top">
                    <img src="assets/portfolio/loginscreen1.jpg" style="height: 500px; width: 400px;" alt="">
                </div>
                <div class="uk-card-body">
                    <h3 class="uk-card-title">Snapchat App</h3>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                    <p> <a class="uk-link" href="ex-project">View Screens</a></p>
                </div>
            </div>
        </div>
    </div>
    </li>
    <li>
        <div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div>
                <div class="uk-card uk-card-default">
                    <div class="uk-card-media-top">
                        <img src="assets/pro8.png"  alt="">
                    </div>
                    <div class="uk-card-body">
                        <h3 class="uk-card-title">Ecommerce Web App</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <p> <a class="uk-link" href="#">Visit Website</a></p>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-default">
                    <div class="uk-card-media-top">
                        <img src="assets/pro9.webp"  alt="">
                    </div>
                    <div class="uk-card-body">
                        <h3 class="uk-card-title">Ecommerce Web App</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <p> <a class="uk-link" href="#">Visit Website</a></p>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-default">
                    <div class="uk-card-media-top">
                        <img src="assets/pro10.jpg"  alt="">
                    </div>
                    <div class="uk-card-body">
                        <h3 class="uk-card-title"> Ecommerce Mobile App</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <p> <a class="uk-link" href="sample">View Screens</a></p>
                    </div>
                </div>
            </div>
            <div>
                <div class="uk-card uk-card-default">
                    <div class="uk-card-media-top">
                        <img src="assets/pro10.webp"  alt="">
                    </div>
                    <div class="uk-card-body">
                        <h3 class="uk-card-title"> Ecommerce Mobile App</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                        <p> <a class="uk-link" href="sample-project">View Screens</a></p>
                    </div>
                </div>
            </div>
        </div>
        </li>
            </ul>
        </div>
    <!-- </div> -->